<section class="mat-typography">
  <h1 [@glow]="glowState" (@glow.done)="glowState = !glowState">
    {{headerText}}
  </h1>
</section>
